import { Link } from 'react-router-dom';
import { useAuth } from '../stores/auth';
import { toast } from '../stores/toasts';
import { useTelegram } from '../hooks/useTelegram';

export function SettingsPage() {
  const auth = useAuth();
  const tg = useTelegram();

  function copy(value: string, label: string) {
    try {
      navigator.clipboard.writeText(value);
      toast.success(`${label} nusxalandi`);
    } catch {
      toast.warning('Clipboard mavjud emas');
    }
  }

  return (
    <>
      <h3>⚙️ Sozlamalar</h3>

      <div className="card">
        <div className="field-label" style={{ marginBottom: 6 }}>Foydalanuvchi</div>
        <div style={{ fontWeight: 600 }}>{auth.user?.name ?? '—'}</div>
        <div className="muted">@{auth.user?.telegramId}</div>
        {auth.user?.phone && (
          <div className="muted">📞 {auth.user.phone}</div>
        )}
      </div>

      {auth.user?.role !== 'CUSTOMER' && (
        <Link to="/subscription" className="card row-between" style={{ textDecoration: 'none', color: 'inherit' }}>
          <div>
            <div style={{ fontWeight: 600 }}>💳 Tarif va obuna</div>
            <div className="muted" style={{ fontSize: 12 }}>Tarif holati va yangilash</div>
          </div>
          <span>›</span>
        </Link>
      )}

      <div className="card">
        <div className="field-label" style={{ marginBottom: 6 }}>Faol usta</div>
        {auth.activeWorkshop ? (
          <>
            <div style={{ fontWeight: 600 }}>{auth.activeWorkshop.name}</div>
            <div className="muted">{auth.activeWorkshop.address ?? auth.activeWorkshop.city ?? '—'}</div>
            <div className="muted">Rol: {auth.activeWorkshop.roleInWorkshop ?? '—'}</div>
          </>
        ) : (
          <div className="muted">Faol usta tanlanmagan</div>
        )}
      </div>

      <div className="card">
        <div className="field-label" style={{ marginBottom: 6 }}>Telegram</div>
        <div className="muted">Mini App versiyasi · 1.0</div>
        <div className="muted">Tillar: O'zbekcha</div>
        <div className="muted">Tema: {tg.webApp?.colorScheme ?? 'auto'}</div>
      </div>

      <div className="card">
        <div className="field-label" style={{ marginBottom: 6 }}>Yordam</div>
        <button className="btn btn-block" onClick={() => copy('https://t.me/autoservice_support', 'Havola')}>
          📞 Qo'llab-quvvatlash
        </button>
        <button className="btn btn-block" style={{ marginTop: 6 }} onClick={() => toast.info('Versiya 1.0.0')}>
          ℹ️ Versiya
        </button>
      </div>

      <button
        className="btn btn-block btn-danger"
        style={{ marginTop: 16 }}
        onClick={() => {
          if (confirm('Tizimdan chiqmoqchimisiz?')) {
            auth.clear();
            tg.webApp?.close();
          }
        }}
      >
        🚪 Chiqish
      </button>
    </>
  );
}
